import React from 'react';

const RenderActive = ({ currentStep, stepComponents, ...restProps }) => {
  const { component, render, ...restStep } = currentStep;

  if (!component && !render) {
    throw new Error(
      'Unsupported Parameter: Wizard Engine: Each step is expected to have a component or render function.'
    );
  }

  if (render) {
    if (typeof render !== 'function') {
      throw new Error(
        `Unsupported Parameter: Wizard Engine: A step's render property expects type of (function); got (${typeof render}).`
      );
    }

    return render({ ...restStep, ...restProps, currentStep });
  }

  const Component = stepComponents[component];

  if (!Component) {
    throw new Error(
      `Unsupported Parameter: Wizard Engine: The component specified for ${currentStep.key} does not exist.`
    );
  }

  return <Component {...restStep} {...restProps} currentStep={currentStep} />;
};

export default RenderActive;



// WEBPACK FOOTER //
// ./src/App/account/components/Wizard/RenderActive.js